import React, { useState, useEffect, useMemo } from "react";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudTable from "../../components/dashboard/table/CrudTable";
import productService from "../../services/productService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function HomeSectionProducts() {
  const [sections, setSections] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ FETCH DATA
  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await productService.getAllHomeSections();
      const sectionsArray = Array.isArray(res.data) ? res.data : res.data?.data || [];
      setSections(sectionsArray);

      const productRes = await productService.getAllProducts();
      const productsArray = Array.isArray(productRes.data) ? productRes.data : productRes.data?.data || [];
      setProducts(productsArray);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ DELETE
const handleDelete = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#124c54",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await productService.deleteHomeSection(id);

        // ✅ SUCCESS POPUP (LIKE YOUR IMAGE)
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Product has been deleted.",
          confirmButtonColor: "#124c54",
        });

        fetchData();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to delete product.",
        });
      }
    }
  });
};

  // ✅ STATUS TOGGLE
const handleToggleStatus = async (item) => {
  try {
    await productService.updateHomeSection(item.id, {
      name: item.name,
      // sort_order: item.sort_order,
      status: item.status ? 0 : 1,
      products: (item.products || []).map((p) =>
        typeof p === "object" ? p.id : p
      ),
    });

    // ✅ SUCCESS POPUP (same like your image)
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Product status updated.",
      confirmButtonColor: "#124c54",
    });

    fetchData();
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "Failed to update status.",
    });
  }
};

  // ✅ TABLE DATA
  const tableData = useMemo(() => {
    return Array.isArray(sections)
      ? sections.map((item, index) => ({
          ...item,
          sl: index + 1,
          products_count: item.products?.length || 0,
        }))
      : [];
  }, [sections]);

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">

        <div className="d-flex justify-content-between align-items-center mb-4"> 
            <button
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            Back
          </button> 
          <button 
            className="btn btn-primary"
            onClick={() => navigate("/admin/create-home-section")}
          >
            Create Home Section
          </button>
        </div>

        <div className="card">
          <div className="card-header">
            <h4>Home Section Products</h4>
          </div>

       {loading ? (
  <div className="d-flex justify-content-center align-items-center p-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
) : (
  <div className="card-body">
    <CrudTable
      data={tableData}
      columns={["sl", "name",  "products_count", "status"]}
      onEdit={(item) => {
        navigate(`/admin/edit-home-section/${item.id}`, { state: { section: item } });
      }}
      onDelete={handleDelete}
      onToggleStatus={handleToggleStatus}
    />
  </div>
)}
        </div>
      </div>
    </DashboardWrapper>
  );
}